import React from 'react';
import { } from 'semantic-ui-react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { dispatch } from '@rematch/core';
import SplitContainer from '@zippytech/react-toolkit/SplitContainer'
import '@zippytech/react-toolkit/SplitContainer/index.css'
import { connect } from 'react-redux';
import SettingList from './DesignerPane/SettingList'
import BaseCategory from './Drive/KnowledgeBank/BaseCategory';
import Tags from './Drive/Tags/Tags'
import Category from './Drive/KnowledgeBank/Category'
import SubCategory from './Drive/KnowledgeBank/SubCategory'
import SettingTree from './BrowserPane/SettingTree'
import WorkspaceLevelSetting from './Drive/WorkspaceLevelSetting/WorkspaceLevelSetting'
import CategoryListingCard from '../../drive/Categories/CategoryListingCard';
import GeneralSettingIndex from './Drive/GeneralSetting/index'
import APIkeys from './Drive/APIkeys/APIkeys'
import AccountPreferenceIndex from './Drive/AccountPreference/index'
import IntegrationsIndex from './Drive/Integrations/index'
import './styles.css';
import ConsumptionDetails from './Drive/Consumptions/ConsumptionDetails';


var moment = require('moment');

class Settings extends React.Component {


  async componentDidMount() {
    await dispatch.integrations.getIntegrations()
    dispatch.app.setOrganisation({})
    dispatch.app.setCurrentContext("acc-setting");
    dispatch.community.setMainAreaContext(null);
    let isDisabled = false;
    let account = this.props.user && this.props.selectedAccount && this.props.user.accounts.filter((account, i) => { return account.id === this.props.selectedAccount._id })[0];
    if (account.role === "user") {
      isDisabled = true;
    } else if (account.role === "customerAdmin" && !account.isActive) {
      isDisabled = true;
    }

    if (isDisabled) {
      this.props.history.push({
        pathname: `/app/${this.props.selectedAccount._id}/dashboard`
      });
    }
  }

  render() {

    return (
      <SplitContainer bordered
        orientation="vertical"
        minSize="10%"
        maxSize={['50%', null]}
        fillSides={[true, true]}
        collapsible={[true, false]}
        defaultSplitAt="15%"
        resizeProxy={true}
      >
        <SplitContainer.Side className="setOverflow " >
          <SettingTree {...this.props} />
        </SplitContainer.Side>

        <SplitContainer.Side className="pad_20" style={{ height: "100%", overflow: 'auto' }} >
          <Switch>
            <Route exact path="/app/:accountId/settings" render={() => (<GeneralSettingIndex  {...this.props} />)} />
            <Route exact path="/app/:accountId/settings/generalSetting" render={() => (<GeneralSettingIndex  {...this.props} />)} />
            <Route exact path="/app/:accountId/settings/accountPreference" render={() => (<AccountPreferenceIndex  {...this.props} />)} />
            <Route exact path="/app/:accountId/settings/integrations" render={() => (<IntegrationsIndex  {...this.props} />)} />
            <Route exact path="/app/:accountId/settings/apikeys" render={() => (<APIkeys  {...this.props} />)} />
            <Route exact path="/app/:accountId/settings/consumptionDetails" render={() => (<ConsumptionDetails  {...this.props} />)} />
            <Route exact path="/app/:accountId/settings/tags" render={() => (<Tags  {...this.props} />)} />
            <Route exact path="/app/:accountId/settings/tags/:baseTagId" render={() => (<Tags  {...this.props} />)} />
            <Route exact path="/app/:accountId/settings/tags/:baseTagId/:tagId" render={() => (<Tags  {...this.props} />)} />
            <Route exact path="/app/:accountId/settings/knowledgeBank" render={() => (<CategoryListingCard  {...this.props} level="account" levelDepth="baseCategory" />)} />
            <Route exact path="/app/:accountId/settings/knowledgeBank/:baseCategoryId" render={() => (<CategoryListingCard  {...this.props} level="account" levelDepth="category" />)} />
            <Route exact path="/app/:accountId/settings/knowledgeBank/:baseCategoryId/:categoryId" render={() => (<CategoryListingCard  {...this.props} level="account" levelDepth="subCategory" />)} />

            <Route exact path="/app/:accountId/settings/usersSharing" render={() => (<GeneralSettingIndex  {...this.props} />)} />
            <Route exact path="/app/:accountId/settings/privacy" render={() => (<GeneralSettingIndex  {...this.props} />)} />
            <Route exact path="/app/:accountId/settings/security" render={() => (<GeneralSettingIndex  {...this.props} />)} />
            <Route exact path="/app/:accountId/settings/paymentAndPurchases" render={() => (<GeneralSettingIndex  {...this.props} />)} />



            {/* <Route exact path="/app/:accountId/settings/knowledgeBank/:baseCategoryId/:categoryId/:subCategoryId" render={() => (<CategoryListingCard  {...this.props} level="account"/>)} /> */}
            {/* <Route exact path="/app/:accountId/settings/knowledgeBank" render={() => (<BaseCategory  {...this.props} />)} />
            <Route exact path="/app/:accountId/settings/knowledgeBank/:baseCategory" render={() => (<Category  {...this.props} />)} />
            <Route exact path="/app/:accountId/settings/knowledgeBank/:baseCategory/:category" render={() => (<SubCategory  {...this.props} />)} />
            <Route exact path="/app/:accountId/settings/knowledgeBank/:baseCategory/:category/:subCategory" render={() => (<SubCategory  {...this.props} />)} /> */}
            <Route exact path="/app/:accountId/settings/workspaceLevelSetting" render={() => (<WorkspaceLevelSetting  {...this.props} />)} />
          </Switch>
        </SplitContainer.Side>

      </SplitContainer>
    )
  }
}

function mapStateToProps(state) {

  return {
    selectedAccount: state.app.selectedAccount,
    organizations: state.app.organizations,
    accountSubscriptionDetail:state.app.accountSubscriptionDetail,
    categoryTree: state.lifeCycle.categoryTree,
    categoryPublicTree: state.lifeCycle.categoryPublicTree,
    baseCategoriesArr: state.lifeCycle.baseCategoriesArr,
    categoriesArr: state.lifeCycle.categoriesArr,
    subCategoriesArr: state.lifeCycle.subCategoriesArr,
    isCategoryChange: state.account.isCategoryChange,
    isAddCategoryModalOpen: state.account.isAddCategoryModalOpen,
    accountLogoObjectCloudinary: state.registerAccount.accountLogoObjectCloudinary,
    loaderStatus: state.registerAccount.loaderBar,
    updateAccountLoader: state.loading.effects.registerAccount.UpdateAccountDetails,
    user: state.app.user,
    InviteUserLoader: state.loading.effects.invite.sendInviteByAccountAsync,
    orgCreationError: state.app.orgCreationError,
    isDeleteCategoryModalOpen: state.account.isDeleteCategoryModalOpen,
    deleteLoader: state.loading.effects.account.deleteCategoryAsync,
    addCategoryLoader: state.loading.effects.account.createCategory,
    selectedCategory: state.account.selectedCategory,
    mainAreaContext: state.community.mainAreaContext,
    categoryTreeId: state.account.categoryTreeId,
    addedAccountUser: state.invite.addedAccountUser,
    envData: state.app.envData,
    tagsTree: state.account.tagsTree,
    tags: state.account.tags,
    tagMap: state.account.tagMap,
    selectedTag: state.account.selectedTag,
    organizationList: state.account.organizationList,
    orgsWithAPIKeys: state.account.orgsWithAPIKeys,
    allCategoryList: state.categories.allCategoryList,
    categoryTreeById: state.categories.categoryTreeById,
    integrationsList:state.integrations.integrationsList, 
    systemNotificationById: state.categories.systemNotificationById,
    categoryListLoader: state.categories.categoryListLoader,
    consumptionDetails: state.account.consumptionDetails,
    loadingConsumptions: state.loading.effects.account.getConsumptionDetails,
    activitiesGenerated: state.account.activitiesGenerated,
    playbooksCreated: state.account.playbooksCreated,
    linksGenerated: state.account.linksGenerated,
    billingDefaults: state.account.billingDefaults,
  };
}

const connectedSettings = connect(mapStateToProps)(Settings);
export { connectedSettings as Settings }; 